import {Link, type LinkProps} from '@primer/react'

import styles from './link-cell.module.css'

export const LinkCell = ({
  ref,
  ...props
}: Omit<LinkProps, 'sx'> & {dangerousHtml?: string; isDisabled?: boolean} & {
  ref?: React.Ref<HTMLAnchorElement | null>
}) => {
  const {isDisabled, ...restProps} = props
  return <Link target="_blank" rel="noreferrer" tabIndex={-1} {...restProps} ref={ref} className={styles.Link} />
}

LinkCell.displayName = 'LinkCell'
